import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVbDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 58 58",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M53 53H5V5H53V53ZM21.1699 33.9502L15.5996 18.04H12L19.4902 38.7002H22.7305L30.3398 18.0596L26.8398 18L21.1699 33.9502ZM32.0098 18.04V38.6904H38.46C40.1499 38.6904 41.7899 38.0897 43.0898 37.0098C43.7298 36.4698 44.2499 35.7699 44.5898 35C44.9298 34.2301 45.0993 33.3802 45.0693 32.5703C45.1293 31.2204 44.6601 29.9201 43.7402 28.9102V28.9199C43.1502 28.3099 42.4296 27.8503 41.6396 27.5703C42.1995 27.2204 42.6997 26.7603 43.0996 26.2305C43.7796 25.3105 44.1401 24.1698 44.1201 23.0498C44.1401 22.36 43.9998 21.6601 43.71 21.0303C43.42 20.4003 42.9796 19.8404 42.4297 19.4004C41.2897 18.5204 39.8599 18.0401 38.4199 18.04H32.0098ZM37.46 29.5205C41.2896 29.5206 41.7294 31.2399 41.7295 32.5498C41.7495 32.9698 41.6698 33.4003 41.5098 33.7803C41.3498 34.1702 41.0898 34.5205 40.7998 34.7705C40.07 35.3303 39.16 35.6395 38.2402 35.6396H35.3301V29.5205H37.46ZM37.46 21.0596C40.4095 21.0596 40.7499 22.4198 40.75 23.4697C40.77 23.8797 40.7 24.29 40.54 24.6699C40.3801 25.0499 40.1296 25.3897 39.8496 25.6396C39.1496 26.1796 38.2794 26.4805 37.3994 26.4805L37.3896 26.4902H35.3193V21.0801L37.46 21.0596Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgVbDark);
export { ForwardRef as ReactComponent };
